import { gql } from '@apollo/client';

export const LIST_NOTIFICATIONS=gql`
    query($first:Int, $page:Int,$tipo:[String]){
    allPushNotifys(first:$first, page:$page,tipo:$tipo){
        data{
            id,
            titulo,
            mensaje,
            contenido,
            tipo,
            fecha,
            audio,

            file_name_url
        },
        total_count
        }
    }
`;